// extracted by mini-css-extract-plugin
export default {"menu":"AvatarMenu_menu__12UQ1","menuItem":"AvatarMenu_menuItem__1BCmh","icon":"AvatarMenu_icon__1DpRp"};